import { Heading, HStack, LinkBox, LinkOverlay, ListItem, VStack } from "@chakra-ui/react"
import React from "react"
import { NavLink } from "react-router-dom"
import { WorkShiftFragment } from "../../graphql"

export type WorkShiftListItemProps = {
	workShift: WorkShiftFragment
}

export const WorkShiftListItem: React.FC<WorkShiftListItemProps> = ({ workShift }) => {
	return (
		<ListItem as={LinkBox} _hover={{ bgColor: "blackAlpha.100" }} transition="background-color .1s ease-in" rounded="xl" cursor="pointer">
			<LinkOverlay as={NavLink} to={`/workShifts/${workShift._id}`} />
			<HStack justifyContent="space-between" p="2">
				<VStack align="flex-start" spacing={0}>
					<Heading fontSize="md" color="grayscale.title">
						{workShift.label.name}
					</Heading>
					<Heading fontSize="sm" color="grayscale.label">
						{workShift.startAt} - {workShift.endAt}
					</Heading>
				</VStack>
			</HStack>
		</ListItem>
	)
}
